(ns frontend.ui.page.lp-report-editor.step-1-initialization.style
  (:require
   [frontend.ui.style.theme.core :as theme]))

(defn add-icon
  []
  {:flex       "1 1 100%"
   :overflow-x "hidden"
   :padding    "0 0 24px"})

(defn holdings-list
  []
  {:display   "flex"
   :gap       "10px"
   :flex-wrap "wrap"
  })

(defn list-item
  []
  (with-meta
    {:border-radius "0.5em"
     :width         "100%"
     :padding       "16px"}
    {:pseudo {":nth-child(even)"
              {:background-color (theme/color [:table :tr :even])}
              ":nth-child(odd)"
              {:background-color (theme/color [:table :tr :odd])}}}))

(defn list-item-heading
  []
  (with-meta
    {:font-size   "1.1em"
     :font-weight "bold"}
    {}))

(defn list-item-label
  []
  (with-meta
    {:font-size   "0.75em"
     :flex        "1 1 auto"
     :font-weight "bold"}
    {}))

(defn template-label-container
  []
  (with-meta
    {:display        "flex"
     :flex-direction "row"
     :padding-top    "16px"
     :gap            "16px"
    }
    {}))

(defn list-item-input
  []
  (with-meta
    {:flex "1 1 auto"
     :overflow-x "clip"}
    {}))

(defn editor-indicator
  []
  (with-meta
    {:color        (theme/color [:palette :danger])
     :padding-left "8px"}
    {}))

(defn chart-editor-input
  []
  (with-meta
    {:flex            "0 0 70px"
     :align-self      "center"
     :display         "flex"
     :flex-direction  "row"
     :justify-content "center"}
    {}))

(defn chart-editor-label
  []
  (with-meta
    {:font-size    "0.75em"
     :font-weight  "bold"
     :justify-self "flex-end"
     :flex         "0 0 auto"}
    {}))

(defn list-item-value
  []
  (with-meta
    {:display        "flex"
     :flex-direction "row"
     :gap            "32px"
     :flex           "1 1 100%"}
    {}))
